/**
 * avatars/presets/textures/species-skin.js
 * Sinh Texture Da Sinh Học Tinh Xảo Cho Các Phần Da Lộ Ra - Dispatcher Registry
 */

import { shadeColor } from '../../../core/color.js';
import { createCanvas } from '../../../core/canvas-texture.js';
import { SPECIES_SKIN_REGISTRY } from './species/index.js';

export function generateSpeciesSkinTexture(_part = 'hands', options = {}) {
  const size = 128;
  const canvas = createCanvas(size, size);
  const ctx = canvas.getContext('2d');

  const skinColor = options.skinColor || '#fcd5b5';
  const speciesId = options.speciesId || '';

  // 1. Lớp da nền với gradient bóng đổ 3D mềm mại
  const grad = ctx.createRadialGradient(size * 0.5, size * 0.5, size * 0.05, size * 0.5, size * 0.5, size * 0.72);
  grad.addColorStop(0, skinColor);
  grad.addColorStop(1, shadeColor(skinColor, -15));
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, size, size);

  // 2. Khớp ngón tay & chi tiết giải phẫu học thanh thoát
  ctx.strokeStyle = shadeColor(skinColor, -22);
  ctx.lineWidth = 2;
  ctx.lineCap = 'round';
  ctx.beginPath();
  ctx.moveTo(size * 0.22, size * 0.38);
  ctx.lineTo(size * 0.78, size * 0.38);
  ctx.moveTo(size * 0.28, size * 0.62);
  ctx.lineTo(size * 0.72, size * 0.62);
  ctx.stroke();

  // 3. HOA VĂN SINH HỌC CHỦNG TỘC (Registry Pattern)
  const drawer = SPECIES_SKIN_REGISTRY[speciesId];
  if (drawer) {
    drawer(ctx, size, options, skinColor);
  }

  return canvas;
}
